import React from "react";

export default function Privacy() {
	return (
		<>
			<div>
				<div>
					<h1 className="text-4xl font-bold text-gray-700 mt-10">
						Privacy Policy
					</h1>
					<div className="py-10 sm:px-20 px-10">
						<p align="justify">
							You certainly understand and concur that:
							<br />
							Tathagat Tutorials Private Limited has created this privacy policy
							in order to demonstrate own organization commitment to privacy.
							Throughout the cyberspace we want to contribute towards providing
							a safe and secure environment, safe information gathering and
							dissemination practices for all our sites. This policy applies to
							tathagat.co.in
							<br />
							<br />
							<strong>Information Gathering And Usage</strong>
							<br />
							<br />
							<strong> 1. Registration / Information</strong>
							<br />
							When you sign up with Website or App we ask you for personal
							information. We may combine the information you submit under your
							account with information from other services / third parties in
							order to provide you with a better experience and to improve the
							quality of our services. For certain services, we may give you the
							opportunity to opt out of combining such information.
							<br />
							You may provide us with certain information such as your Name,
							E-mail address, Correspondence address when registering for
							certain services such as Online Registration / Submit Resume,
							Contests. This information will primarily be used for the purpose
							of providing personalisation and verification.
							<br />
							<br />
							<strong>2. Cookies</strong>
							<br />
							A cookie is a small data file that Websites or App write to your
							hard drive when you visit them. A cookie file can contain
							information such as a user ID that the site uses to track the
							pages you have visited. A cookie can contain information you
							supply yourself. A cookie can't read data of your hard disk or
							read cookie files created by other sites. Our Website/App uses
							cookies to track user traffic patterns and for the personalisation
							feature.
							<br />
							<br />
							<strong>3. User communications</strong>
							<br />
							When you send email or other communications to our Website or App
							, we may retain those communications in order to process your
							inquiries, respond to your requests and improve our services. When
							you send and receive SMS messages to or from one of our services
							that provides SMS functionality, we may collect and maintain
							information associated with those messages, such as the phone
							number, the content of the message, and the date and time of the
							transaction. We may use your email address to communicate with you
							about our services.
							<br />
							<br />
							<strong>4. Log information</strong>
							<br />
							When you access our Website via a browser our servers
							automatically record certain information. These server logs may
							include information such as your web request, your interaction
							with a service, Internet Protocol address, browser type, browser
							language, the date and time of your request and one or more
							cookies that may uniquely identify your browser or your account.
							<br />
							<br />
							<strong>5. Confidential</strong>
							<br />
							Tathagat Tutorials Private Limited Privacy Policy applies to its
							Website. Tathagat Tutorials Private Limited do not exercise
							control over the sites displayed as search results, sites that
							include other applications, products or services, or links from
							within our various services. Personal information that you provide
							to other sites may be sent to our Website and/or App in order to
							deliver the service. We process such information under this
							Privacy Policy.
							<br />
							<br />
							<strong>6. Feedback </strong>
							<br />
							Tathagat Tutorials Private Limited Feedback Form requires personal
							information of users like contact number, name and e-mail address
							and demographic information like their zip code, age etc. for any
							feedback by the users pertaining to the services rendered by
							Tathagat Tutorials Private Limited.
							<br />
							<br />
							<strong>7. Further Improvement</strong>
							<br />
							Apart from the above, we may use user information to provide,
							maintain, protect, improve and develop our services.
							<br />
							<br />
							<strong>8. Queries regarding the Website or APP</strong>
							<br />
							If you have any query regarding this Privacy Policy, you may
							contact at info@tathagat.co.in.
						</p>
					</div>
				</div>
			</div>
		</>
	);
}
